export class FsrDvT6ss {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00';
        this.inputSelected = 1;
        this.mute = false;
        this.volume = 50;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /#FW-VERSION\?/i,
                callback: (match) => {
                    this.socket.send(`<FW-VERSION ${this.firmwareVersion}>`);
                },
            },
            {
                name: 'handShake',
                regExp: /#HANDSHAKE/i,
                callback: (match) => {
                    this.socket.send(`<SUCCESS>`);
                },
            },
            {
                name: 'getRoute',
                regExp: /#INPUT-SEL\?/i,
                callback: (match) => {
                    this.socket.send(`<INPUT-SEL ${this.inputSelected}>`);
                },
            },
            {
                name: 'setRoute',
                regExp: /#INPUT-SEL (\d+)/i,
                callback: (match) => {
                    const input = parseInt(match[1], 10);
                    this.inputSelected = input;
                    this.socket.send(`<INPUT-SEL ${this.inputSelected}>`);
                },
            },
            {
                name: 'getVolume',
                regExp: /#AUD-VOL\?/i,
                callback: (match) => {
                    this.socket.send(`<AUD-VOL ${this.volume}>`);
                },
            },
            {
                name: 'setVolume',
                regExp: /#AUD-VOL (\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`<AUD-VOL ${this.volume}>`);
                },
            },
            {
                name: 'getMute',
                regExp: /#AUD-MUTE\?/i,
                callback: (match) => {
                    this.socket.send(`<AUD-MUTE ${this.mute ? '1' : '0'}>`);
                },
            },
            {
                name: 'setMute',
                regExp: /#AUD-MUTE (\d+)/i,
                callback: (match) => {
                    this.mute = match[1] === '1';
                    this.socket.send(`<AUD-MUTE ${this.mute ? '1' : '0'}>`);
                },
            },
        ];
    }
}
FsrDvT6ss.emulatorType = 'socketEmulator';
FsrDvT6ss.key = '-MqGncB-qE-aJ47jsIim';
